module.exports = __webpack_public_path__ + "static/media/paintCanWrong.b627ec9c.png";